<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productGroupOrderReturn.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="productGroupOrderReturnInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              v-model="productGroupOrderReturnInfo.conditions.returnId"
              :placeholder="$t('productGroupOrderReturn.returnIdPlaceholder')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="productGroupOrderReturnInfo.conditions.orderId"
              :placeholder="$t('productGroupOrderReturn.orderIdPlaceholder')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="productGroupOrderReturnInfo.conditions.returnType"
              :placeholder="$t('productGroupOrderReturn.returnTypePlaceholder')"
              style="width:100%"
              clearable
            >
              <el-option
                label="自主退款"
                value="1001"
              />
              <el-option
                label="拼团失败退款"
                value="2002"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="_queryProductGroupOrderReturnMethod"
            >
              <i class="el-icon-search"></i>
              {{ $t('productGroupOrderReturn.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productGroupOrderReturn.title') }}</div>
      </div>
      <div class="">
        <el-table
          :data="productGroupOrderReturnInfo.orders"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="returnId"
            :label="$t('productGroupOrderReturn.returnId')"
            align="center"
          />
          <el-table-column
            prop="orderId"
            :label="$t('productGroupOrderReturn.orderId')"
            align="center"
          />
          <el-table-column
            prop="prodName"
            :label="$t('productGroupOrderReturn.product')"
            align="center"
          />
          <el-table-column
            prop="buyerName"
            :label="$t('productGroupOrderReturn.buyer')"
            align="center"
          />
          <el-table-column
            prop="buyerCount"
            :label="$t('productGroupOrderReturn.quantity')"
            align="center"
          />
          <el-table-column
            prop="groupPrice"
            :label="$t('productGroupOrderReturn.groupPrice')"
            align="center"
          />
          <el-table-column
            prop="returnMoney"
            :label="$t('productGroupOrderReturn.refundAmount')"
            align="center"
          />
          <el-table-column
            prop="returnType"
            :label="$t('productGroupOrderReturn.refundType')"
            align="center"
          >
            <template #default="{row}">
              {{ row.returnType === '1001' ? '自主退款' : '拼团失败退款' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="reason"
            :label="$t('productGroupOrderReturn.refundReason')"
            align="center"
          />
          <el-table-column
            prop="state"
            :label="$t('productGroupOrderReturn.status')"
            align="center"
          />
          <el-table-column
            prop="stateMsg"
            :label="$t('productGroupOrderReturn.auditNote')"
            align="center"
          />
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="productGroupOrderReturnInfo.conditions.page"
          :page-size="productGroupOrderReturnInfo.conditions.row"
          layout="total, prev, pager, next"
          :total="productGroupOrderReturnInfo.total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listProductGroupOrderReturn } from '@/api/group/productGroupOrderReturnApi'

export default {
  name: 'ProductGroupOrderReturn',
  data() {
    return {
      productGroupOrderReturnInfo: {
        orders: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          returnId: '',
          orderId: '',
          returnType: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.productGroupOrderReturnInfo.conditions.shopId = getShopId()
    this._listProductGroupOrderReturns(1, 10)
  },
  methods: {
    async _listProductGroupOrderReturns(page, rows) {
      this.productGroupOrderReturnInfo.conditions.page = page
      this.productGroupOrderReturnInfo.conditions.row = rows
      try {
        const res = await listProductGroupOrderReturn(this.productGroupOrderReturnInfo.conditions)
        this.productGroupOrderReturnInfo.total = res.total
        this.productGroupOrderReturnInfo.records = res.records
        this.productGroupOrderReturnInfo.orders = res.data
      } catch (error) {
        console.error('获取退单列表失败:', error)
      }
    },
    _queryProductGroupOrderReturnMethod() {
      this._listProductGroupOrderReturns(1, 10)
    },
    handleCurrentChange(val) {
      this._listProductGroupOrderReturns(val, this.productGroupOrderReturnInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  padding: 15px 20px 20px 20px;
}
</style>